import { FlexLayoutRootComponent } from './flex-layout-root.component';
import { FlexLayoutSectionComponent } from './flex-layout-section.component';
import { MaterialAddReferenceComponent } from './material-add-reference.component';
import { MaterialOneOfComponent } from './material-one-of.component';
import { MaterialButtonComponent } from './material-button.component';
import { MaterialButtonGroupComponent } from './material-button-group.component';
import { MaterialCheckboxComponent } from './material-checkbox.component';
import { MaterialCheckboxesComponent } from './material-checkboxes.component';
import { MaterialChipListComponent } from './material-chip-list.component';
import { MaterialDatepickerComponent } from './material-datepicker.component';
import { MaterialFileComponent } from './material-file.component';
import { MaterialInputComponent } from './material-input.component';
import { MaterialNumberComponent } from './material-number.component';
import { MaterialRadiosComponent } from './material-radios.component';
import { MaterialSelectComponent } from './material-select.component';
import { MaterialSliderComponent } from './material-slider.component';
import { MaterialStepperComponent } from './material-stepper.component';
import { MaterialTabsComponent } from './material-tabs.component';
import { MaterialTextareaComponent } from './material-textarea.component';

import { MaterialDesignFrameworkComponent } from './material-design-framework.component';

export const MATERIAL_FRAMEWORK_COMPONENTS = [
  FlexLayoutRootComponent, FlexLayoutSectionComponent,
  MaterialAddReferenceComponent, MaterialOneOfComponent,
  MaterialButtonComponent, MaterialButtonGroupComponent,
  MaterialCheckboxComponent, MaterialCheckboxesComponent,
  MaterialChipListComponent, MaterialDatepickerComponent,
  MaterialFileComponent, MaterialInputComponent, MaterialNumberComponent,
  MaterialRadiosComponent, MaterialSelectComponent, MaterialSliderComponent,
  MaterialStepperComponent, MaterialTabsComponent, MaterialTextareaComponent,
  MaterialDesignFrameworkComponent
];

export { FlexLayoutRootComponent } from './flex-layout-root.component';
export { FlexLayoutSectionComponent } from './flex-layout-section.component';
export { MaterialAddReferenceComponent } from './material-add-reference.component';
export { MaterialOneOfComponent } from './material-one-of.component';
export { MaterialButtonComponent } from './material-button.component';
export { MaterialButtonGroupComponent } from './material-button-group.component';
export { MaterialCheckboxComponent } from './material-checkbox.component';
export { MaterialCheckboxesComponent } from './material-checkboxes.component';
export { MaterialChipListComponent } from './material-chip-list.component';
export { MaterialDatepickerComponent } from './material-datepicker.component';
export { MaterialFileComponent } from './material-file.component';
export { MaterialInputComponent } from './material-input.component';
export { MaterialNumberComponent } from './material-number.component';
export { MaterialRadiosComponent } from './material-radios.component';
export { MaterialSelectComponent } from './material-select.component';
export { MaterialSliderComponent } from './material-slider.component';
export { MaterialStepperComponent } from './material-stepper.component';
export { MaterialTabsComponent } from './material-tabs.component';
export { MaterialTextareaComponent } from './material-textarea.component';

export { MaterialDesignFrameworkComponent } from './material-design-framework.component';



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/lib/src/framework-library/material-design-framework/index.ts